<template>
  <div
    class="radio-group"
    :class="{&quot;has-error&quot;: localErrors.length}"
  >
    <slot />
    <x-errors-messages :errors="localErrors" />
  </div>
</template>

<script>
  import xErrorsMessages from './x-errors-messages'
  let groupId = 0

  export default {
    name: 'XRadioGroup',
    components: {
      'x-errors-messages': xErrorsMessages
    },
    props: {
      errors: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        id: `x-radio-group-${groupId++}`,
        localErrors: []
      }
    },

    watch: {
      errors () {
        this.localErrors = this.errors
      }
    },
    methods: {
      updateValue (value) {
        this.localErrors = []
        this.$emit('update', value)
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .has-error {
    input {
      border-color: $color-red;
    }

    label {
      color: $color-red;
    }
  }

  .errors-messages {
    padding: 0.6rem 1.4rem;
    font-size: 1.4rem;
  }
</style>
